<template>
    <div :style="{'height':clientHeight-90+'px'}">
        <div >
            <div class="m-portlet m-b-10" :style="{'height':100+'px'}">
                <div class="m-portlet__body">
                    <el-form label-position="right" label-width="90px">
                        <el-row :gutter="20">
                            <el-col :span="6">
                                <el-form-item label="校区">
                                    <el-select v-model="filter.section_id" clearable placeholder="请选择校区" filterable remote
                                               @change="handleChange()"
                                               style="width: 200px">
                                        <el-option
                                                v-for="item in sections"
                                                :key="item.id"
                                                :label="item.name"
                                                :value="item.id">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="期数">
                                    <el-select v-model="filter.sort" clearable placeholder="请选期数" filterable remote
                                               @change="handleChange()"
                                               style="width: 200px">
                                        <el-option
                                                v-for="item in sorts"
                                                :key="item.sort"
                                                :label="item.date"
                                                :value="item.sort">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="对比期数">
                                    <el-select v-model="filter.contrast_sort" clearable placeholder="请选择对比期数" filterable remote
                                               @change="handleContrastFinancialInvoiceShopPanel()"
                                               style="width: 200px">
                                        <el-option
                                                v-for="item in sorts"
                                                :key="item.sort"
                                                :label="item.date"
                                                :value="item.sort">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                </div>
            </div>

            <div :style="{'height':(clientHeight-280)+'px'}">
                <div class="m-portlet m-b-10" v-if="powers.includes(152) && Object.keys(sum_invoiceShopPanels).length>0">
                    <div class="m-portlet__body" v-loading="loading" :style="{'height':200+sum_height+'px'}" @click="heightChange('sum')">
                        <div style="font-size: 15px;height: 20px" v-if="sorts[filter.sort]">{{sorts[filter.sort].date}}汇总</div>
                        <el-table  v-if="!loading"
                                   :data="sum_invoiceShopPanels"
                                   style="width: 100%"
                                   :height="150+sum_height"
                                   size="middle">
                            <el-table-column prop="section_name" label="校区"></el-table-column>
                            <el-table-column label="现金">
                                <template slot-scope="scope">
                                    {{scope.row.sum_cash|currency('￥',2)}}
                                </template>
                            </el-table-column>
                            <el-table-column label="钱包">
                                <template slot-scope="scope">
                                    {{scope.row.sum_wallet|currency('￥',2)}}
                                </template>
                            </el-table-column>
                            <el-table-column label="折扣">
                                <template slot-scope="scope">
                                    {{scope.row.sum_discount|currency('￥',2)}}
                                </template>
                            </el-table-column>
                            <el-table-column label="预收">
                                <template slot-scope="scope">
                                    {{scope.row.sum_advance|currency('￥',2)}}
                                </template>
                            </el-table-column>
                            <el-table-column label="暂估">
                                <template slot-scope="scope">
                                    {{scope.row.sum_estimate|currency('￥',2)}}
                                </template>
                            </el-table-column>
                            <el-table-column label="余额">
                                <template slot-scope="scope">
                                    {{scope.row.sum_balance|currency('￥',2)}}
                                </template>
                            </el-table-column>
                            <el-table-column  label="收入">
                                <template slot-scope="scope">
                                    {{scope.row.sum_income|currency('￥',2)}}
                                </template>
                            </el-table-column>
                            <el-table-column  label="财务自检">
                                <template slot-scope="scope">
                                    {{scope.row.sum_checkFinancial|currency('￥',2)}}
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
                <div class="m-portlet m-b-10" v-if="powers.includes(152) && Object.keys(contrast_invoiceShopPanels).length>0">
                    <div class="m-portlet__body" v-loading="loading" :style="{'height':200+contrast_height+'px'}" @click="heightChange('contrast')">
                        <div  style="font-size: 15px;height: 20px" v-if="sorts[filter.contrast_sort] && sorts[filter.sort]">{{sorts[filter.contrast_sort].date}}对比{{sorts[filter.sort].date}}</div>
                        <el-table  v-if="!loading"
                                   :data="contrast_invoiceShopPanels"
                                   style="width: 100%"
                                   :height="150+contrast_height"
                                   size="middle">
                            <el-table-column prop="section_name" label="校区"></el-table-column>
                            <el-table-column label="现金">
                                <template slot-scope="scope">
                                    {{scope.row.sum_cash|currency('￥',2)}}
                                </template>
                            </el-table-column>
                            <el-table-column label="钱包">
                                <template slot-scope="scope">
                                    {{scope.row.sum_wallet|currency('￥',2)}}
                                </template>
                            </el-table-column>
                            <el-table-column label="折扣">
                                <template slot-scope="scope">
                                    {{scope.row.sum_discount|currency('￥',2)}}
                                </template>
                            </el-table-column>
                            <el-table-column label="预收">
                                <template slot-scope="scope">
                                    {{scope.row.sum_advance|currency('￥',2)}}
                                </template>
                            </el-table-column>
                            <el-table-column label="暂估">
                                <template slot-scope="scope">
                                    {{scope.row.sum_estimate|currency('￥',2)}}
                                </template>
                            </el-table-column>
                            <el-table-column label="余额">
                                <template slot-scope="scope">
                                    {{scope.row.sum_balance|currency('￥',2)}}
                                </template>
                            </el-table-column>
                            <el-table-column  label="收入">
                                <template slot-scope="scope">
                                    {{scope.row.sum_income|currency('￥',2)}}
                                </template>
                            </el-table-column>
                            <el-table-column  label="财务自检">
                                <template slot-scope="scope">
                                    {{scope.row.sum_checkFinancial|currency('￥',2)}}
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
                <div class="m-portlet m-b-10" v-if="powers.includes(152)">
                    <div class="m-portlet__body" :style="{'height':clientHeight-350-classListHeight+list_height+'px'}" @click="heightChange('list')">
                        <el-table  v-if="!loading"
                                   :data="invoiceShopPanels"
                                   style="width: 100%"
                                   :height="clientHeight-382-classListHeight+list_height"
                                   size="middle">
                            <el-table-column prop="invoice_id" label="合同ID"></el-table-column>
                            <el-table-column prop="student_name" label="学生"></el-table-column>
                            <el-table-column prop="section_name" label="校区"></el-table-column>
                            <el-table-column label="现金">
                                <template slot-scope="scope">
                                    {{scope.row.cash|currency('￥',2)}}
                                </template>
                            </el-table-column>
                            <el-table-column label="钱包">
                                <template slot-scope="scope">
                                    {{scope.row.wallet|currency('￥',2)}}
                                </template>
                            </el-table-column>
                            <el-table-column label="折扣">
                                <template slot-scope="scope">
                                    {{scope.row.discount|currency('￥',2)}}
                                </template>
                            </el-table-column>
                            <el-table-column label="预收">
                                <template slot-scope="scope">
                                    {{scope.row.advance|currency('￥',2)}}
                                </template>
                            </el-table-column>
                            <el-table-column label="暂估">
                                <template slot-scope="scope">
                                    {{scope.row.estimate|currency('￥',2)}}
                                </template>
                            </el-table-column>
                            <el-table-column  label="余额">
                                <template slot-scope="scope">
                                    {{scope.row.balance|currency('￥',2)}}
                                </template>
                            </el-table-column>
                            <el-table-column label="收入">
                                <template slot-scope="scope">
                                    {{scope.row.income|currency('￥',2)}}
                                </template>
                            </el-table-column>
                            <el-table-column label="财务自检">
                                <template slot-scope="scope">
                                    {{scope.row.checkFinancial|currency('￥',2)}}
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="m-portlet__foot">
                        <div class="text-center m-t-10">
                            <el-pagination
                                    @size-change="handleSizeChange"
                                    @current-change="handleCurrentChange"
                                    :current-page="currentPage"
                                    :page-sizes="[10, 20, 50, 100]"
                                    :page-size="10"
                                    layout="total, sizes, prev, pager, next, jumper"
                                    :total="total">
                            </el-pagination>
                        </div>
                    </div>
                </div>
            </div>

        </div>

    </div>
</template>

<script>
    export default {
        name: 'FinancialInvoice-list',
        data() {
            return {
                path: "/financial/panel",
                loading: true,
                sorts:[],
                sections:[],
                sum_invoiceShopPanels:[],
                invoiceShopPanels:[],
                contrast_invoiceShopPanels:[],

                filter:{
                    section_id:'',
                    sort:'',
                    contrast_sort:'',
                },
                currentPage: 1,
                currentPageSize: 10,
                total:0,
                sum_height:0,
                contrast_height:0,
                list_height:0,
            }
        },
        created() {
            this.handleCreate();

        },
        computed: {
            powers() {
                return this.$store.state.config.powers;
            },
            clientHeight() {
                return this.$store.state.config.clientHeight
            },
            classListHeight(){
                var  height=0;
                if(Object.keys(this.sum_invoiceShopPanels).length>0){
                    height=height+200;
                }
                if(Object.keys(this.contrast_invoiceShopPanels).length>0){
                    height=height+200;
                }
                return height;
            }
        },
        methods: {
            heightChange(type){
                if(type=='sum'){
                    this.sum_height=200;
                    if(Object.keys(this.contrast_invoiceShopPanels).length>0){
                        this.contrast_height=-100;
                        this.list_height=-100;
                    }else{
                        this.contrast_height=0;
                        this.list_height=-200;
                    }

                }else if(type=='contrast'){
                    if(Object.keys(this.sum_invoiceShopPanels).length>0){
                        this.sum_height=-100;
                        this.list_height=-100;
                    }else{
                        this.sum_height=0;
                        this.list_height=-200;
                    }
                    this.contrast_height=200;
                }else if(type=='list'){
                    if(Object.keys(this.contrast_invoiceShopPanels).length>0){
                        this.sum_height=-100;
                        this.contrast_height=-100;
                        this.list_height=200;
                    }else{
                        this.sum_height=-150;
                        this.contrast_height=0;
                        this.list_height=150;
                    }
                }
            },
            handleCreate() {
                //建立webSocket链接
                this.$wApi.addListen(this.path, this.handleData);
                this.$wApi.send(this.path, 'financial_invoice_shop_init');
            },
            handleData(event, data) {
                switch (event) {
                    case 'financial_invoice_shop_init':
                        this.sorts=data.sorts
                        this.sections=data.sections
                        this.filter.sort=data.sort;
                        this.handleFinancialInvoiceShopPanel();
                        break;
                    case 'financial_invoiceShop_panel':
                        this.sum_invoiceShopPanels=data.sum_invoiceShopPanels
                        this.invoiceShopPanels=data.invoiceShopPanels
                        this.total=data.total
                        this.loading = false;
                        break;
                    case 'contrast_financial_shop_panel':
                        this.contrast_invoiceShopPanels=data.contrast_invoiceShopPanels
                        this.loading = false;
                        break;
                }
            },
            handleFinancialInvoiceShopPanel(currentPage=1){
                if (currentPage===1){
                    this.currentPage=1
                }
                this.$wApi.send(this.path, 'financial_invoice_shop_panel', {
                    'currentPage': currentPage,
                    'currentPageSize': this.currentPageSize,
                    'filter':this.filter
                });
            },
            handleChange(){
                this.handleFinancialInvoiceShopPanel();
                this.handleContrastFinancialInvoiceShopPanel();
            },
            handleContrastFinancialInvoiceShopPanel(){
                this.loading = true;
                this.$wApi.send(this.path, 'contrast_financial_shop_panel', {
                    'filter':this.filter
                });
            },
            handleSizeChange(val) {
                this.currentPageSize = val;
                this.loading = true;
                this.handleFinancialInvoiceShopPanel(this.currentPage)
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.loading = true;
                this.handleFinancialInvoiceShopPanel(this.currentPage)
            },

        }
    }
</script>
